import { Heading } from "@tiptap/extension-heading";

const HHHeadingInline = Heading.extend({
  name: "hhHeadingInline",
  priority: 1000,
  addAttributes() {
    return {
      ...this.parent?.(),
      class: {
        default: null, // No default class
        parseHTML: (element) =>
          element.className
            .split(" ")
            .filter((className) => className !== "hh-heading-inline"), // Filter out 'hh-heading-inline' class
        renderHTML: (attributes) => {
          const existingClasses = attributes.class ? attributes.class : [];
          if (!existingClasses.includes("hh-heading") && !existingClasses.includes("hh-heading-inline")) {
            existingClasses.push("hh-heading-inline");
          }
          return {
            class: existingClasses.join(" "),
          };
        },
      },
    };
  },
});

export default HHHeadingInline;
